import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
// Third party packages
import { MatDialog, MatDialogRef } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { DdtsService } from "src/app/modules/ddts/ddts.service";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { UsersService } from "src/app/modules/users/users.service";
import { PrintQrDialogComponent } from "src/app/shared/components/dialogs/print-qr-dialog/print-qr-dialog.component";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
/**
 * Script start
 */
var PropertyDetailDocumentPrintModuleDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PropertyDetailDocumentPrintModuleDialogComponent(dialogRef, cancelContractDialog, data, configService, propertiesService, translateService, authService, cookieService, dialog, toastrService, helperService, usersService, ddtsService) {
        this.dialogRef = dialogRef;
        this.cancelContractDialog = cancelContractDialog;
        this.data = data;
        this.configService = configService;
        this.propertiesService = propertiesService;
        this.translateService = translateService;
        this.authService = authService;
        this.cookieService = cookieService;
        this.dialog = dialog;
        this.toastrService = toastrService;
        this.helperService = helperService;
        this.usersService = usersService;
        this.ddtsService = ddtsService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.dialogIsLoading = true; // Used to view/hide form loading spinner
        this.printModuleBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.printModule"),
            spinnerSize: 19,
            raised: false,
            stroked: false,
            flat: true,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-print",
                inline: true,
            },
        };
        this.printQrBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.printLabel"),
            spinnerSize: 19,
            raised: false,
            stroked: false,
            flat: true,
            fab: false,
            buttonColor: "accent",
            spinnerColor: "accent",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-qrcode",
                inline: true,
            },
        };
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentPrintModuleDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        console.log(this.data);
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return (_this.loggedUser = res); }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        this.dialogIsLoading = false;
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentPrintModuleDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle print file qrCode
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentPrintModuleDialogComponent.prototype.onPrint = function (target) {
        var _this = this;
        var qrCodes = [];
        var barCode = this.data.itemData.barCode;
        if (typeof barCode === "undefined" || barCode === "") {
            this.toastrService.error("No qrCodes to inject");
            return;
        }
        barCode = barCode.toUpperCase();
        if (barCode.slice(-1) === "C") {
            this.subscriptions.push(this.ddtsService.getDdtdocumentByCode(barCode).subscribe(function (res) {
                var e_1, _a;
                if (res.status) {
                    if (res.data &&
                        res.data.files &&
                        Array.isArray(res.data.files)) {
                        try {
                            for (var _b = tslib_1.__values(res.data.files), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var file = _c.value;
                                if (file && file.name) {
                                    qrCodes.push(file.name);
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    }
                    // Fallback: paper document without usable DDT file names -> encode the barCode (same as digital docs)
                    if (!qrCodes.length) {
                        qrCodes.push(barCode);
                    }
                    var data = void 0;
                    if (target === "qr") {
                        data = {
                            target: target,
                            qrCodes: qrCodes,
                            propertyName: _this.data.property.name,
                            propertyCity: _this.data.property.address.city,
                            propertyAddress: _this.data.property.address.route + ", " + _this.data.property.address.streetNumber,
                            area: _this.data.area,
                            docs: _this.data.docs,
                        };
                    }
                    else if (target === "module") {
                        data = {
                            target: target,
                            qrCodes: qrCodes,
                            propertyName: _this.data.property.name,
                            propertyCity: _this.data.property.address.city,
                            propertyAddress: _this.data.property.address.route + ", " + _this.data.property.address.streetNumber,
                            area: _this.data.area,
                            uploadDate: _this.data.itemData.createdAt,
                            content: _this.data.itemData.contenutoDocumento,
                            docs: _this.data.docs,
                            structures: _this.data.structure,
                        };
                    }
                    else {
                        _this.toastrService.error("missing print target");
                    }
                    console.log("data", data);
                    // Open dialog
                    _this.dialog.open(PrintQrDialogComponent, {
                        data: data,
                        width: "600px",
                    });
                }
                else {
                    // Non c'è il DDT perchè è un documento importato dlala 1
                    qrCodes.push(barCode);
                    var data = void 0;
                    if (target === "qr") {
                        data = {
                            target: target,
                            qrCodes: qrCodes,
                            propertyName: _this.data.property.name,
                            propertyCity: _this.data.property.address.city,
                            propertyAddress: _this.data.property.address.route + ", " + _this.data.property.address.streetNumber,
                            area: _this.data.area,
                            docs: _this.data.docs,
                        };
                    }
                    else if (target === "module") {
                        data = {
                            target: target,
                            qrCodes: qrCodes,
                            propertyName: _this.data.property.name,
                            propertyCity: _this.data.property.address.city,
                            propertyAddress: _this.data.property.address.route + ", " + _this.data.property.address.streetNumber,
                            area: _this.data.area,
                            uploadDate: _this.data.itemData.createdAt,
                            content: _this.data.itemData.contenutoDocumento,
                            docs: _this.data.docs,
                            structures: _this.data.structure,
                        };
                    }
                    else {
                        _this.toastrService.error("missing print target");
                    }
                    // Open dialog
                    _this.dialog.open(PrintQrDialogComponent, {
                        data: data,
                        width: "600px",
                    });
                }
            }, function (err) {
                // if we came here users with given userId do not exist
                _this.helperService.handleError(err);
            }));
        }
        else {
            qrCodes.push(barCode);
            var data = void 0;
            if (target === "qr") {
                data = {
                    target: target,
                    qrCodes: qrCodes,
                    propertyName: this.data.property.name,
                    propertyCity: this.data.property.address.city,
                    propertyAddress: this.data.property.address.route + ", " + this.data.property.address.streetNumber,
                    area: this.data.area,
                    docs: this.data.docs,
                };
            }
            else if (target === "module") {
                data = {
                    target: target,
                    qrCodes: qrCodes,
                    propertyName: this.data.property.name,
                    propertyCity: this.data.property.address.city,
                    propertyAddress: this.data.property.address.route + ", " + this.data.property.address.streetNumber,
                    area: this.data.area,
                    uploadDate: this.data.itemData.createdAt,
                    content: this.data.itemData.contenutoDocumento,
                    docs: this.data.docs,
                    structures: this.data.structure,
                };
            }
            else {
                this.toastrService.error("missing print target");
            }
            // Open dialog
            this.dialog.open(PrintQrDialogComponent, {
                data: data,
                width: "600px",
            });
        }
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentPrintModuleDialogComponent.prototype.onClose = function (data) {
        this.dialogRef.close(data);
    };
    return PropertyDetailDocumentPrintModuleDialogComponent;
}());
export { PropertyDetailDocumentPrintModuleDialogComponent };
